import React from 'react';
import Card from '../../common/Card/Card';
import styles from './OverviewSections.module.css';

const COLUMNS = [
  { key: 'now', label: 'Now' },
  { key: 'afterReview', label: 'After review' },
  { key: 'then', label: 'Then' },
];

/**
 * Your Submission Roadmap: Now / After review / Then. A column with no title
 * and no text is left out; renders nothing when the roadmap is empty.
 */
const SubmissionRoadmap = ({ roadmap }) => {
  const columns = COLUMNS
    .map((c) => ({ ...c, item: roadmap?.[c.key] }))
    .filter((c) => c.item && (c.item.title || c.item.text));
  if (!columns.length) return null;

  return (
    <Card title="Your Submission Roadmap">
      <div className={styles.roadmap}>
        {columns.map((c) => (
          <div
            key={c.key}
            className={`${styles.roadmapCol} ${c.key === 'now' ? styles.roadmapNow : ''}`}
          >
            <span className={styles.eyebrow}>{c.label}</span>
            {c.item.title && <div className={styles.roadmapTitle}>{c.item.title}</div>}
            {c.item.text && <p className={styles.roadmapText}>{c.item.text}</p>}
          </div>
        ))}
      </div>
    </Card>
  );
};

export default SubmissionRoadmap;
